module.exports = __webpack_public_path__ + "images/spin-doctor-642c292bb61dff3c6ce08441e7d02306.png";